<template>
  <div class="w-100 hero-banner-container">
    <v-carousel
      :show-arrows="false"
      :cycle="false"
      :interval="5000"
      cover
      height="540px"
      class="custom-carousel"
      hide-delimiters
      hide-delimiter-background
      v-model="currentSlide"
      @change="handleChange"
    >
      <v-carousel-item
        v-for="(item, i) in images"
        :key="i"
        class="carousel-item-container"
      >
        <v-sheet class="slide-container align-center">
          <v-col
            xl="6"
            lg="8"
            md="10"
            sm="10"
            xs="10"
            class="slide-data"
            :class="responsiveClass"
          >
            <template v-if="heroTitle">
              <span class="white--text banner-title pr-3">{{ heroTitle }}</span>
              <p class="white--text banner-subtitle pr-6">
                {{ heroDescription }}
              </p>
            </template>
            <!-- No heroTitle prop: copy comes from the whitelabel section,
                 same fields HomeHeroBar renders (boldTitle/title/subtitle/disclaimer). -->
            <template v-else>
              <div>
                <span
                  v-if="item.boldTitle"
                  class="white--text banner-title bolder"
                  >{{ item.boldTitle }}&nbsp;</span
                >
                <span class="white--text banner-title pr-3">{{
                  item.title
                }}</span>
              </div>
              <p class="white--text banner-subtitle pr-6">
                {{ item.subtitle }}
              </p>
              <p
                v-if="item.disclaimer"
                class="white--text banner-disclaimer pr-6"
              >
                {{ item.disclaimer }}
              </p>
            </template>
            <GradientButton
              v-if="!!heroButtonText"
              :title="heroButtonText"
              @gradientButtonClicked="buttonAction(heroButtonLink)"
            />
          </v-col>
        </v-sheet>
        <v-img
          v-if="!isMobile"
          :src="item.src"
          :srcset="item.srcset"
          :sizes="item.sizes"
          :alt="item.alt"
          class="carousel-img"
          cover
          eager
        />
        <v-img
          v-else-if="isPortrait && isPad"
          :src="item.iPadMiniSrc"
          :alt="item.alt"
          class="carousel-img"
          cover
          eager
        />
        <v-img
          v-else-if="isPortrait"
          :src="item.mobileSrc"
          :alt="item.alt"
          class="carousel-img"
          cover
          eager
        />
        <v-img
          v-else
          :src="item.landscapeSrc"
          :srcset="item.srcset"
          :sizes="item.sizes"
          :alt="item.alt"
          class="carousel-img"
          cover
          eager
        />
      </v-carousel-item>
    </v-carousel>
    <QuickStartCard
      v-if="hasQuickStartCallout"
      :titles="quickStartTitles"
      :hasCallout="hasQuickStartCallout"
      @quickStartCardLinkClicked="quickStartCardLinkClicked"
    />
  </div>
</template>
<script>
  import QuickStartCard from '../guest/home/QuickStartCard.vue';

  export default {
    name: 'DefaultHeroBar',
    components: {
      QuickStartCard,
    },
    data() {
      return {
        isPortrait: this.$orientation,
        currentSlide: 0,
        responsiveClass: this.getClassBasedOnBreakpoint(
          this.$vuetify.breakpoint.name
        ),
      };
    },
    props: {
      hasQuickStartCallout: {
        required: true,
        default: false,
        type: Boolean,
      },
      quickStartTitles: {
        required: false,
        default: null,
        type: Array,
      },
      heroTitle: {
        required: false,
        default: '',
        type: String,
      },
      heroDescription: {
        required: false,
        default: '',
        type: String,
      },
      heroButtonText: {
        required: false,
        default: '',
        type: String,
      },
      heroButtonLink: {
        required: false,
        default: '',
        type: String,
      },
      section: {
        required: false,
        default: '',
        type: String,
      },
    },
    watch: {
      '$vuetify.breakpoint.name'(newBreakpoint) {
        this.responsiveClass = this.getClassBasedOnBreakpoint(newBreakpoint);
      },
      $orientation(newVal) {
        this.isPortrait = newVal;
      },
    },
    created() {},
    computed: {
      isMobile() {
        return this.$isMobileDevice();
      },
      isPad() {
        return this.$isPad();
      },
      images() {
        return this.whitelabel.images[this.section].heroBarSourceSets.map(
          set => {
            const srcset = set.srcset.map(srcobj => {
              return { url: srcobj.url, width: srcobj.width };
            });

            return {
              src: require(`@/assets/${set.src}`),
              landscapeSrc: require(`@/assets/${set.landscapeSrc}`),
              mobileSrc: require(`@/assets/${set.mobileSrc}`),
              iPadMiniSrc: require(`@/assets/${set.iPadMiniSrc}`),
              srcset: srcset
                .map(set => {
                  try {
                    const imagePath = require(`@/assets/${set.url}`);
                    return `${imagePath} ${set.width},`;
                  } catch (error) {
                    console.error(`Image not found: ${set.url}`, error);
                    return '';
                  }
                })
                .join(' '),
              sizes: set.sizes,
              alt: set.alt,
              boldTitle: set.boldTitle,
              title: set.title,
              subtitle: set.subtitle,
              disclaimer: set.disclaimer,
              buttonText: set.buttonText,
              buttonLink: set.buttonLink,
            };
          }
        );
      },
    },
    methods: {
      quickStartCardLinkClicked(routeName) {
        this.$emit('quickStartCardLinkClicked', routeName);
      },
      handleChange(newSlide) {
        this.currentSlide = newSlide;
      },
      setSlide(index) {
        this.currentSlide = index;
      },
      getClassBasedOnBreakpoint(breakpoint) {
        if (this.isMobile) {
          if (this.isPortrait) {
            return 'banner-sm';
          } else {
            return 'banner-sm-landscape';
          }
        } else {
          switch (breakpoint) {
            case 'xs':
              return 'banner-xs';
            case 'sm':
              return 'banner-sm';
            case 'md':
              return 'banner-md';
            case 'lg':
              return 'banner-lg';
            case 'xl':
              return 'banner-xl';
            default:
              return '';
          }
        }
      },
      buttonAction(path) {
        this.$router.push({ name: path });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .hero-banner-container {
    position: relative;
  }
  .custom-carousel .v-carousel__item {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .carousel-img {
    width: 100%;
    height: 540px;
    object-fit: cover;
  }

  .overlay-content {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
  }

  .slide-container {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: 0;
    z-index: 11;
    background: transparent !important;
    background-color: transparent !important;
    display: flex;
    align-items: center;

    .slide-data {
      font-feature-settings: 'clig' off, 'liga' off;
      font-family: 'Montserrat', sans-serif;
    }
  }

  //Banner Content
  .banner-xs {
    padding-left: 12px;
    padding-top: 120px;

    .banner-subtitle {
      letter-spacing: 0.15px;
    }
    .bolder {
      font-weight: 400 !important;
    }
  }

  .banner-sm {
    padding-left: 12px;
    padding-top: 40px;
    .banner-title {
      font-style: normal;
      font-weight: 400;
    }
    .banner-subtitle {
      font-style: normal;
      font-weight: 500;
      letter-spacing: 0.15px;
    }
    .bolder {
      font-weight: 500 !important;
    }
  }

  .banner-sm-landscape {
    padding-left: 20px;
    .banner-title {
      font-style: normal;
      font-weight: 400;
    }
    .banner-subtitle {
      font-style: normal;
      font-weight: 500;
      letter-spacing: 0.15px;
    }
    .bolder {
      font-weight: 500 !important;
    }
  }

  .banner-md {
    padding-left: 76px;
    .banner-title {
      font-style: normal;
      font-weight: 400;
    }
    .banner-subtitle {
      font-style: normal;
      font-weight: 500;
      letter-spacing: 0.15px;
    }
    .bolder {
      font-weight: 500 !important;
    }
  }

  .banner-lg {
    padding-left: 74px;
    .banner-title {
      font-style: normal;
      font-weight: 300;
      letter-spacing: -1.5px;
    }
    .banner-subtitle {
      font-style: normal;
      font-weight: 400;
    }
    .bolder {
      font-weight: 500 !important;
    }
  }

  .banner-xl {
    padding-left: 100px;
    .banner-title {
      font-style: normal;
      font-weight: 300;
      letter-spacing: -1.5px;
    }
    .banner-subtitle {
      font-style: normal;
      font-weight: 400;
    }
    .bolder {
      font-weight: 400 !important;
    }
  }

  .banner-button-green {
    border-radius: 30px;
    background: var(
      --Gradients-Fresh-Heritage-Horizontal,
      linear-gradient(270deg, #60b848 1.64%, #009677 98.36%)
    );
  }

  .v-carousel__controls {
    background-color: transparent;
    bottom: 0;
    position: absolute;
    width: 100%;
    justify-content: center;
  }
  .custom-delimiter-container {
    position: absolute;
    width: 100%;
    bottom: 1em;
    z-index: 11;
    display: flex;
    align-items: center;
    justify-content: center;

    button {
      &.active {
        width: 25px !important;
      }
      &.inactive {
        width: 11px !important;
      }
    }
  }

  .delimiter-icon {
    height: auto;

    &.inactive {
      .v-image__image {
        width: 11px;
      }
    }
  }
  @media screen and (max-width: 600px) {
    .custom-delimiter-container {
      bottom: 0;
    }
  }

  .banner-title {
    font-size: clamp(
      38px,
      calc((68 - 38) / (1600 - 1260) * (100vw - 1260px) + 38px),
      68px
    ) !important;
    line-height: clamp(
      42px,
      calc((72 - 42) / (1600 - 1260) * (100vw - 1260px) + 42px),
      72px
    ) !important;
  }
  .banner-subtitle {
    max-width: 80%;
    font-size: 22px !important;
    line-height: 26px !important;
    padding-top: clamp(12px, 2vw + 8px, 24px);
  }

  // Hero footnote under the subtitle (spec 2.2 "Hero footnote").
  .banner-disclaimer {
    max-width: 80%;
    margin-top: 40px;
    margin-bottom: 0;
    font-size: 16px !important;
    line-height: 26px !important;
    letter-spacing: -0.04px;
    font-weight: 400;
  }
</style>
